export enum FeeScheduleTemplateOrderField {
  Name = "Name",
  CreatedDate = "CreatedDate",
  Tags = "Tags",
}
